"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const table_1 = __importDefault(require("@kyruus/table"));
exports.Table = (0, styled_1.default)(table_1.default) `
  tbody > tr > td {
    padding: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
//# sourceMappingURL=styles.js.map